/**
 * Luz que sigue al puntero sobre las tarjetas `.spotlight` (estándar §1.6, `followSpotlight`).
 * Un solo manejador en <main> para toda la página —con uno por tarjeta habría decenas de
 * escuchas para un efecto decorativo— y solo con ratón: con el dedo no hay «encima».
 * Únicamente escribe dos variables CSS; el pintado lo hace el navegador.
 */
export function iniciarFoco(): void {
  const raiz = document.querySelector<HTMLElement>("[data-foco]");
  if (!raiz || !window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

  raiz.addEventListener(
    "pointermove",
    (e) => {
      if (e.pointerType !== "mouse") return;
      const tarjeta = (e.target as HTMLElement).closest<HTMLElement>(".spotlight");
      if (!tarjeta) return;
      const r = tarjeta.getBoundingClientRect();
      tarjeta.style.setProperty("--mx", `${e.clientX - r.left}px`);
      tarjeta.style.setProperty("--my", `${e.clientY - r.top}px`);
    },
    { passive: true },
  );
}
